import React from "react";

import Box from "components/common/Box";
import Text from "components/common/Text";

const FeatureGrid = ({ features, classes }) => (
  <Box className={classes.featureGrid}>
    {features.map((feature) => (
      <Box key={feature.title} className={classes.featureGridCard}>
        {feature.icon ? (
          <Box
            component="img"
            src={feature.icon}
            alt=""
            className={classes.featureGridIcon}
            draggable={false}
          />
        ) : (
          <Box className={classes.featureGridIconSlot} aria-hidden />
        )}
        <Text className={classes.featureGridTitle}>{feature.title}</Text>
      </Box>
    ))}
  </Box>
);

export default FeatureGrid;
